import axios from 'axios';
import qs from 'qs';
import { camelizeKeys } from 'humps';
import { connect } from 'react-redux';

import { 
  logoutSuccess
} from '../store/action';
const accessToken = localStorage.getItem('access_token');
/**
 *
 * parse error response
 */
function parseError(messages) {
  // error
  if (messages) {
    if (messages instanceof Array) {
      return Promise.reject({ messages });
    }
    return Promise.reject({ messages: [messages] });
  }
  return Promise.reject({ messages: ['錯誤'] });
}

/**
 * parse response
 */
function parseBody(response) {
  if (response.status === 200 && response.data.message.length === 0) {
    return response.data.result == null ? response.data.status : response.data.result;
  }else{
    if(response.data.message[0].length > 0)
      return response.data.message[0];
    else
      return this.parseError(response.data.message[0]);

  }
}

/**
 * axios instance
 */
const instance = axios.create({
  
  baseURL: process.env.REACT_APP_NODE_ENV === 'development'?'https://www.liangshishu.link:46890/api/':'https://www.liangshishu.link:46888/api/',
  // timeout: 5000,
  headers: { 
    Authorization: `Bearer ${accessToken}`,
    StoreId: `${localStorage.getItem('current_store_id')}`
   },
  responseType: 'json',
  paramsSerializer(params) {
    return qs.stringify(params, { indices: false });
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    const storeId = localStorage.getItem('current_store_id');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.StoreId = `${storeId}`;
    }
    return config;
  },
  (error) => {
    // return Promise.reject(error)
    if (error.response) {
      return parseError(error.response.data);
    }
    return Promise.reject(error);
  },
);

// response parse
instance.interceptors.response.use(response => parseBody(camelizeKeys(response)), (error) => {
  console.log(error)
  console.warn('Error status', error.response.status);
  if(error.response.status === 401 || error.response.status === 403){
    // 401 未授權或 403 權限不足，清除登入資訊並導向登入頁
    localStorage.removeItem('isLogin');
    localStorage.removeItem('adminName');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    localStorage.removeItem('role1');
    localStorage.removeItem('role2');
    localStorage.removeItem('role3');
    localStorage.removeItem('access_token');
    localStorage.removeItem('all_store_id');
    //localStorage.removeItem('current_store_id');
    alert('登入已過期或權限不足，請重新登入');
    window.location.href = '/';

  }else if(error.response.status === 500){
    alert('發生錯誤，請回報工程師')

  }
  // return Promise.reject(error)
  if (error.response) {
    return parseError(error.response.data);
  }
  return Promise.reject(error);
});

export default instance
